var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, Input, Paper, Select, Skeleton, Switch } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useEffect, useState } from "react";
import { getCategoryOptions } from "../../../helpers/CategoryHelper";
import { useForm } from "@mantine/form";
import { useNavigate } from "react-router";
export default function CloudForm(_a) {
    var onUpdate = _a.onUpdate, onStartCreate = _a.onStartCreate, onEndCreate = _a.onEndCreate;
    var navigate = useNavigate();
    var _b = useState([]), childOptions = _b[0], setChildOptions = _b[1];
    var form = useForm({
        initialValues: {
            child: '',
            date: null,
            category: '',
            pronunciation: false,
        },
        validate: {
            child: function (value) { return (value ? null : 'Please choose one'); },
            date: function (value) { return (value ? null : 'Please choose a date'); },
        },
    });
    var handleSubmit = function (values) {
        var params = new URLSearchParams({
            pronunciation: values.pronunciation ? 'true' : 'false',
            date: values.date,
            category: values.category,
        });
        onStartCreate();
        fetch("/api/child/".concat(values.child, "/cloud-items?").concat(params), {
            method: 'GET',
        })
            .then(function (res) {
            try {
                switch (res.status) {
                    case 200:
                        res.json().then(function (res) {
                            onUpdate(res);
                            onEndCreate();
                        });
                        break;
                    case 401:
                        navigate('/login');
                        break;
                    default:
                }
            }
            catch (error) { }
        });
    };
    useEffect(function () {
        fetch('/api/children', {
            method: 'GET'
        })
            .then(function (res) {
            if (res.status === 401) {
                navigate('/login');
            }
            return res;
        })
            .then(function (res) { return res.json(); })
            .then(function (res) {
            var output = [];
            for (var i = 0; i < res.length; i++) {
                output.push({ value: res[i].uuid, label: res[i].name });
            }
            setChildOptions(output);
        });
    }, []);
    return _jsx(Paper, { p: "md", radius: "md", withBorder: true, style: {
            borderLeft: '4px solid #228be6', // Mantine primary blue
            backgroundColor: '#ffffff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
        }, children: _jsx(Box, { component: "form", onSubmit: form.onSubmit(handleSubmit), children: _jsxs(Flex, { direction: { base: 'column', sm: 'row' }, gap: "md", align: { base: 'stretch', sm: 'flex-start' }, children: [childOptions === null
                        ? _jsx(Skeleton, {})
                        : _jsx(Select, __assign({ label: "Child", placeholder: "Choose...", data: childOptions, style: { flex: 1 } }, form.getInputProps('child'))), _jsx(DatePickerInput, __assign({ label: "Date", placeholder: "Pick a date", style: { flex: 1 } }, form.getInputProps('date'))), _jsx(Select, __assign({ label: "Category", placeholder: "Choose...", data: __spreadArray([
                            { value: '', label: 'All' }
                        ], getCategoryOptions(), true), style: { flex: 1 } }, form.getInputProps('category'))), _jsx(Input.Wrapper, { label: "Pronunciations", children: _jsx(Flex, { h: 36, align: "center", children: _jsx(Switch, __assign({ "aria-label": "Pronunciations" }, form.getInputProps('pronunciation', { type: 'checkbox' }))) }) }), _jsx(Box, { pt: { base: 0, sm: 24.5 }, w: { base: '100%', sm: 'auto' }, children: _jsx(Button, { type: "submit", fullWidth: true, children: "Create" }) })] }) }) });
}
